export default "__VITE_ASSET__CxGJLzEA__"